import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BaseExplorer } from "@/components/bases/BaseExplorer";
import { BaseGlyph } from "@/components/bases/baseUtils";
import { Container, SectionHeading } from "@/components/common/ui";
import { useBases } from "@/hooks/useData";

export default function BasesPage() {
  const bases = useBases();
  return (
    <div data-testid="bases-page">
      <BaseExplorer className="h-[100svh] min-h-[640px]" variant="page" testId="bases-explorer" />
      <section className="py-16 sm:py-20">
        <Container>
          <SectionHeading eyebrow="Directory" title="Every installation we serve" subtitle="Open any base for a cinematic 3D view, the homes around it and how far each one is." />
          <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {bases.map((b) => (
              <Link key={b.id} to={`/bases/${b.id}`} data-testid={`base-card-${b.id}`}
                className="group flex flex-col rounded-md border border-neutral-200 p-5 transition-[border-color,box-shadow] hover:border-ink hover:shadow-[0_18px_40px_-24px_rgba(0,0,0,0.35)]">
                <div className="flex items-center justify-between">
                  <BaseGlyph base={b} />
                  <ArrowUpRight className="h-5 w-5 text-neutral-400 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" />
                </div>
                <p className="mt-4 text-lg font-medium text-ink">{b.name}</p>
                <p className="text-[13px] text-neutral-500">{b.branch} · {b.city}, VA · {b.region}</p>
                <p className="mt-3 flex-1 text-[14px] leading-relaxed text-neutral-600">{b.summary}</p>
                <p className="mt-4 font-mono text-[11px] uppercase tracking-widest text-brass-deep">{b.homes_within} homes within 10 mi</p>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
